import { connect } from 'react-redux';
import { handleFBLogin } from 'services/socials';
import FacebookLoginButton from './view';

const mapDispatchToProps = dispatch => ({
  handleFBLogin: () => dispatch(handleFBLogin()),
});

export default connect(null, mapDispatchToProps)(FacebookLoginButton);
